import type { useFormatNumber } from '../../../../../core/hooks/useFormatNumber'

type FormatNumber = ReturnType<typeof useFormatNumber>

export const formatMarginRate = (formatNumber: FormatNumber, ratio: number | null) =>
  formatNumber(ratio ?? null, '--', {
    style: 'percent',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })
